module.exports = __webpack_public_path__ + "media/components/assets/img/icons/transport-22fb655611d692d4c0a11dedbd45610d.svg";